import DesktopIcon from './component'

export default DesktopIcon
